import _JSXStyle from "styled-jsx/style";
import { useConfig } from '@dhis2/app-runtime';
import { colors } from '@dhis2/ui-constants';
import { MenuItem } from '@dhis2-ui/menu';
import PropTypes from 'prop-types';
import React from 'react';
import { useHeaderBarContext } from '../header-bar-context.js';
import i18n from '../locales/index.js';
export function UpdateNotification(_ref) {
  let {
    hideProfileMenu
  } = _ref;
  const {
    appName
  } = useConfig();
  const {
    updateAvailable,
    onApplyAvailableUpdate
  } = useHeaderBarContext();
  const onClick = () => {
    hideProfileMenu();
    onApplyAvailableUpdate === null || onApplyAvailableUpdate === void 0 ? void 0 : onApplyAvailableUpdate();
  };
  const updateNotificationLabel = /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["4135170305", [colors.blue600]]]) + " " + "root"
  }, /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["4135170305", [colors.blue600]]]) + " " + "badge"
  }), /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["4135170305", [colors.blue600]]]) + " " + "spacer"
  }), /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["4135170305", [colors.blue600]]]) + " " + "message"
  }, appName ? i18n.t('New {{appName}} version available', {
    appName
  }) : i18n.t('New app version available'), /*#__PURE__*/React.createElement("br", {
    className: _JSXStyle.dynamic([["4135170305", [colors.blue600]]])
  }), i18n.t('Click to reload')), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4135170305",
    dynamic: [colors.blue600]
  }, [".root.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;line-height:17px;}", `.badge.__jsx-style-dynamic-selector{display:inline-block;width:12px;height:12px;margin:0 8px;border-radius:6px;background-color:${colors.blue600};}`, ".spacer.__jsx-style-dynamic-selector{display:inline-block;width:8px;}", ".message.__jsx-style-dynamic-selector{display:inline-block;}"]));
  return updateAvailable ? /*#__PURE__*/React.createElement(MenuItem, {
    dense: true,
    onClick: onClick,
    label: updateNotificationLabel,
    dataTest: "dhis2-ui-headerbar-updatenotification"
  }) : null;
}
UpdateNotification.propTypes = {
  hideProfileMenu: PropTypes.func.isRequired
};